import get from 'lodash/get'
import includes from 'lodash/includes'
import isNumber from 'lodash/isNumber'
import isObject from 'lodash/isObject'
import pick from 'lodash/pick'

import {
  GenderType,
  GenderTypeMapping,
  BudgetType,
  PlacementsSetupType,
  PlacementsDeviceType,
  InteractionType,
} from './constants'
import { isFlexibleSpecItemIsNotEmpty } from './helpers'

// const EXCLUDE_DETAILED_TARGETING = [
//   'geo_locations',
//   'excluded_geo_locations',
//   'age_max',
//   'age_min',
//   'genders',
//   'locales',
//   'custom_audiences',
//   'excluded_custom_audiences',
//   'targeting_optimization',
//   'publisher_platforms',
//   'facebook_positions',
//   'instagram_positions',
//   'device_platforms',
//   'messenger_positions',
//   'relationship_statuses',
//   'flexible_spec',
//   'product_audience_specs',
//   'dynamic_audience_ids',
//   'excluded_publisher_list_ids',
//   'audience_network_positions',
//   'app_install_state',
// ]
//
// const INCLUDE_DETAILED_TARGETING = [
//   'interests',
//   'behaviors',
//   'education_schools',
//   'education_majors',
//   'work_employers',
//   'work_positions',
//   'user_adclusters',
//   'life_events',
//   'politics',
//   'industries',
//   'income',
//   'net_worth',
//   'home_type',
//   'home_ownership',
//   'generation',
//   'household_composition',
//   'moms',
//   'family_statuses',
//   'office_type',
// ]
//
// adgroup_id, genders, age_min, age_max, country_groups, countries, country, cities, radius, regions, zips, interests, keywords, education_schools, education_majors, work_positions, work_employers, relationship_statuses, interested_in, locales, user_adclusters, excluded_user_adclusters, conjunctive_user_adclusters, custom_audiences, excluded_custom_audiences, college_years, education_statuses, connections, excluded_connections, friends_of_connections, user_event, dynamic_audience_ids, excluded_dynamic_audience_ids, rtb_flag, site_category, geo_locations, excluded_geo_locations, timezones, place_page_set_ids, page_types, publisher_platforms, effective_publisher_platforms, facebook_positions, effective_facebook_positions, instagram_positions, effective_instagram_positions, messenger_positions, effective_messenger_positions, device_platforms, effective_device_platforms, audience_network_positions, effective_audience_network_positions, whatsapp_positions, effective_whatsapp_positions, excluded_publisher_categories, excluded_publisher_list_ids, publisher_visibility_categories, user_device, mobile_device_model, excluded_user_device, excluded_mobile_device_model, user_os, wireless_carrier, family_statuses, industries, life_events, political_views, politics, behaviors, income, net_worth, home_type, home_ownership, home_value, ethnic_affinity, generation, household_composition, moms, office_type, targeting_optimization, direct_install_devices, engagement_specs, excluded_engagement_specs, product_audience_specs, excluded_product_audience_specs, exclusions, flexible_spec, exclude_reached_since, exclude_previous_days, app_install_state, fb_deal_id, interest_defaults_source, alternate_auto_targeting_option, contextual_targeting_categories, topic, format, trending, gatekeepers, follow_profiles, follow_profiles_negative, location_categories, user_page_threads, user_page_threads_excluded, is_whatsapp_destination_ad, marketplace_product_categories, instream_video_sponsorship_placements
//
// connections
// friends_of_connections
// custom_audiences
// interests
// user_adclusters
// behaviors
// college_years
// education_majors
// education_schools
// education_statuses
// family_statuses
// generation
// home_type
// home_ownership
// home_value
// household_composition
// interested_in
// income
// industries
// life_events
// moms
// net_worth
// office_type
// politics
// relationship_statuses
// work_positions
// work_employers

export const parseItem = (item) => {
  let daily = null
  let lifetime = null
  if (isObject(item.budget)) {
    daily = get(item, 'budget.daily')
    lifetime = get(item, 'budget.lifetime')
  } else {
    daily = parseInt(item.daily_budget) ? parseInt(item.daily_budget) : null
    lifetime = parseInt(item.lifetime_budget) ? parseInt(item.lifetime_budget) : null
  }
  const budget = isNumber(daily) ? daily : lifetime

  const genderTargets = get(item, 'targeting.genders')
  let genders = GenderType.ALL
  if (includes(genderTargets, 1) && includes(genderTargets, 2)) {
    genders = GenderType.ALL
  } else if (includes(genderTargets, 1)) {
    genders = GenderType.MALE
  } else if (includes(genderTargets, 2)) {
    genders = GenderType.FEMALE
  }

  const startTime = get(item, 'start_time', null)
  const endTime = get(item, 'end_time', null)
  const createdTime = get(item, 'created_time', null)

  // Old format for saving targeting
  const detailedTargeting = pick(item.targeting, 'interests', 'behaviors')
  let flexibleSpec = get(item.targeting, 'flexible_spec', null)

  if (detailedTargeting && isFlexibleSpecItemIsNotEmpty(detailedTargeting)) {
    flexibleSpec = flexibleSpec ? [detailedTargeting, ...flexibleSpec] : [detailedTargeting]
  }

  if (!flexibleSpec || (Array.isArray(flexibleSpec) && flexibleSpec.length === 0)) {
    flexibleSpec = [
      {
        interests: [],
        behaviors: [],
      },
    ]
  }

  const devicePlatformsData = get(item, 'targeting.device_platforms')
  let placementsSetup = devicePlatformsData
    ? PlacementsSetupType.EDIT
    : PlacementsSetupType.AUTOMATIC

  let placementsDeviceType = PlacementsDeviceType.ALL
  if (devicePlatformsData) {
    if (
      devicePlatformsData.includes(PlacementsDeviceType.DESKTOP) &&
      devicePlatformsData.includes(PlacementsDeviceType.MOBILE)
    )
      placementsDeviceType = PlacementsDeviceType.ALL
    else if (devicePlatformsData.includes(PlacementsDeviceType.DESKTOP))
      placementsDeviceType = PlacementsDeviceType.DESKTOP
    else if (devicePlatformsData.includes(PlacementsDeviceType.MOBILE))
      placementsDeviceType = PlacementsDeviceType.MOBILE
  }

  let publisherPlatforms = []
  let placementsPositions = []
  if (get(item, 'targeting.publisher_platforms')) {
    publisherPlatforms = [...item.targeting['publisher_platforms']]
  }
  if (publisherPlatforms.length) {
    publisherPlatforms.map((platform) => {
      const platformPositions = item.targeting[platform + '_positions']
      placementsPositions = [
        ...placementsPositions,
        ...platformPositions.map((p) => `${platform}.${p}`),
      ]
    })
  }

  return {
    ...item,
    name: get(item, 'name', ''),
    schedule: endTime && startTime ? 'later' : 'now',
    startTime,
    endTime,
    createdTime,
    budgetType: isNumber(lifetime) ? BudgetType.LIFETIME : BudgetType.DAILY,
    budget,
    bidAmount: item.bid_amount,
    dsa_beneficiary: item.dsa_beneficiary,
    dsa_payor: item.dsa_payor,

    // targeting
    custom_audiences: (get(item, 'targeting.custom_audiences') || []).map(
      (audience) => audience.id || audience,
    ),
    excluded_custom_audiences: (get(item, 'targeting.excluded_custom_audiences') || []).map(
      (audience) => audience.id || audience,
    ),
    minAge: get(item, 'targeting.age_min', 18),
    maxAge: get(item, 'targeting.age_max', 65),
    genders,
    locales: get(item, 'targeting.locales') || [],
    geo_locations: get(item, 'targeting.geo_locations'),
    excluded_geo_locations: get(item, 'targeting.excluded_geo_locations'),
    flexibleSpec,
    exclusions: get(item.targeting, 'exclusions', null),

    placementsSetup,
    placementsDeviceType,
    placementsPositions,
  }
}

export const exportItem = (item, interactionType) => {
  const budget = {}

  if (item.budgetType === BudgetType.DAILY) {
    budget.daily = item.budget
  }

  if (item.budgetType === BudgetType.LIFETIME) {
    budget.lifetime = item.budget
  }

  let start_time = null
  let end_time = null
  if (item.schedule !== 'now' || item.budgetType === BudgetType.LIFETIME) {
    start_time = item.startTime
    end_time = item.endTime
  }

  let device_platforms = null
  if (item.placementsSetup === PlacementsSetupType.EDIT) {
    if (item.placementsDeviceType === PlacementsDeviceType.ALL)
      device_platforms = [PlacementsDeviceType.DESKTOP, PlacementsDeviceType.MOBILE]
    else if (item.placementsDeviceType === PlacementsDeviceType.MOBILE)
      device_platforms = [PlacementsDeviceType.MOBILE]
    else if (item.placementsDeviceType === PlacementsDeviceType.DESKTOP)
      device_platforms = [PlacementsDeviceType.DESKTOP]
  }

  let publisher_platforms = []
  let platform_positions = []
  if (item.placementsSetup === PlacementsSetupType.EDIT) {
    item.placementsPositions.map((position) => {
      const platform = position.substring(0, position.indexOf('.'))
      if (!publisher_platforms.includes(platform))
        publisher_platforms = [...publisher_platforms, platform]

      const platformKey = platform + '_positions'
      if (!platform_positions[platformKey]) platform_positions[platformKey] = []
      platform_positions[platformKey] = [
        ...platform_positions[platformKey],
        position.replace(`${platform}.`, ''),
      ]
    })
  }

  const result = {
    name: item.name,
    start_time,
    end_time,
    budget,
    dsa_beneficiary: item.dsa_beneficiary,
    dsa_payor: item.dsa_payor,
    targeting: {
      custom_audiences: item.custom_audiences,
      excluded_custom_audiences: item.excluded_custom_audiences,
      age_max: item.maxAge,
      age_min: item.minAge,
      genders: GenderTypeMapping[item.genders] || [],
      locales: item.locales,
      geo_locations: item.geo_locations,
      excluded_geo_locations: item.excluded_geo_locations,
      flexible_spec: item.flexibleSpec.filter(isFlexibleSpecItemIsNotEmpty),
      exclusions: item.exclusions,
      device_platforms,
      publisher_platforms,
      ...platform_positions,
    },
  }

  if (interactionType === InteractionType.SPONSORED_MESSAGE) {
    result.targeting.messenger_positions = [InteractionType.SPONSORED_MESSAGE]
    result.targeting.device_platforms = ['desktop', 'mobile']
    result.targeting.publisher_platforms = ['messenger']

    result.pacing_type = ['no_pacing']
    result.bid_strategy = 'LOWEST_COST_WITH_BID_CAP'
    result.bid_amount = item.bidAmount
  }

  return result
}

export const parseDevicePlatforms = (deviceType, data) => {
  return {
    deviceType,
    dependencies: data['dependencies'],
    allowedPositions: data['allowed_positions'],
    platforms: data['platforms']
      .map((item) => {
        const platform = {
          label: item.title,
          name: item.name,
          defaultOpen: true,
          subItems: item['positions']
            .filter((child) => data['allowed_positions'].includes(`${item.name}.${child.name}`))
            .map((child) => {
              return { label: child.title, name: `${item.name}.${child.name}` }
            }),
        }
        return platform
      })
      .filter((item) => item.subItems.length),
  }
}

export default {
  parseItem,
  exportItem,

  parseDevicePlatforms,
}
